export default "__VITE_ASSET__fbb2b066__"